import React, { useState } from 'react';
import slugify from 'slugify';
import client from '../../../../../lib/client';
import { groupMembersQuery, inviteMemberToGroupMutation } from '../../../../../queries/groups';
import {
  InviteMemberToGroupMutation,
  InviteMemberToGroupMutationVariables
} from '../../../../../queries/__generated__/InviteMemberToGroupMutation';
import { Option, Options, Select, Selected } from '../../../../forms';
import { Badge } from '../../../../ui';

interface HasAvailableMembersProps {
  closeModal(): void;
  group: {
    id: string;
    name: string;
    slug: string;
  };
  members: {
    id: string;
    displayName: string;
    membershipStatus: string;
    user: {
      email: string;
    };
  }[];
}

const HasAvailableMembers: React.FC<HasAvailableMembersProps> = ({
  closeModal,
  group,
  members
}) => {
  const [invitee, setInvitee] = useState<{
    id: string;
    displayName: string;
    user: { email: string };
  } | null>(null);

  const [isSelectingMember, setIsSelectingMember] = useState(false);

  async function sendInvite(memberId: string) {
    await client.mutate<InviteMemberToGroupMutation, InviteMemberToGroupMutationVariables>({
      mutation: inviteMemberToGroupMutation,
      variables: { input: { groupId: group.id, memberId } },
      refetchQueries: [{ query: groupMembersQuery, variables: { input: { groupId: group.id } } }]
    });
    closeModal();
  }

  return (
    <>
      <div className="pa3">
        <h1 className="tc display f4 fw8 tc">Add a Contributor to {group.name}</h1>
        <Select>
          <Selected
            onClick={() => setIsSelectingMember(!isSelectingMember)}
            data-testid="members-select"
          >
            {invitee ? invitee.displayName || invitee.user.email : 'Select a member'}
          </Selected>
          {isSelectingMember && (
            <Options onClickOutside={() => setIsSelectingMember(false)}>
              <Option onClick={() => setIsSelectingMember(false)}>
                <span className="moon-gray">Select a member</span>
              </Option>

              {members.map(member => (
                <Option
                  key={member.id}
                  onClick={() => {
                    setInvitee(member);
                    setIsSelectingMember(false);
                  }}
                  data-testid={slugify(member.displayName)}
                >
                  {member.displayName || member.user.email}
                  {member.membershipStatus === 'PENDING' && <Badge className="ml1">Pending</Badge>}
                </Option>
              ))}
            </Options>
          )}
        </Select>
      </div>
      <div className="flex bt b--light-gray">
        <button
          className="flex-auto pa3 blue hover-navy tc f6 br b--light-gray"
          onClick={closeModal}
        >
          Cancel
        </button>
        <button
          className="flex-auto pa3 blue hover-navy tc f6 fw5"
          onClick={() => sendInvite(invitee!.id)}
          disabled={!invitee}
          data-testid="send-invite-button"
        >
          Add Contributor
        </button>
      </div>
    </>
  );
};

export default HasAvailableMembers;
